var Theme;
(function (Theme) {
  Theme.getLight = function (primaryColor) {
    return {
      listItemHoverBg: '$whiteA9',
      listItemActiveBg: '$whiteA8',
      listItemFocusBorder: primaryColor.helpers.pickScale(8)
    };
  };
  Theme.getDark = function (primaryColor) {
    return {
      listItemHoverBg: '$whiteA4',
      listItemActiveBg: '$whiteA3',
      listItemFocusBorder: primaryColor.helpers.pickScale(11)
    };
  };
})(Theme || (Theme = {}));

export { Theme };
